<template>
  <div class="admin-login">
    <div class="logo-container">
      <img src="@/images/admin-logo@2x.png" alt />
    </div>
    <div class="login-container">
      <div class="title">輸入帳號</div>
      <div class="text">
        <input type="text" v-model="accountNumber" :class="{ error: accountNumberError }" />
      </div>
      <div class="title">輸入密碼</div>
      <div class="text">
        <input type="password" v-model="accountPassword" :class="{ error: accountPasswordError }" />
      </div>
    </div>
    <span>{{this.errorMessage}}</span>
    <div class="button-container">
      <button @click="login">登入</button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Cookies from "js-cookie";
export default {
  name: "adminLogin",
  data() {
    return {
      accountNumber: "",
      accountPassword: "",
      accountNumberError: false,
      accountPasswordError: false,
      errorMessage: null
    };
  },
  beforeRouteEnter(to, from, next) {
    if (Cookies.getJSON("goldAdminUser") === undefined) {
      next();
    } else {
      next(vm => {
        let cookieData = Cookies.getJSON("goldAdminUser");
        vm.$store.dispatch("setBackstageToken", cookieData.api_token);
        vm.$store.dispatch("setAdminLevel", cookieData.level);
        vm.$router.push({ name: "admin_orderList" });
      });
    }
  },
  methods: {
    async login() {
      let loginDataVerificationResult = this.loginDataVerification();
      try {
        let loginResponse = await this.$store.dispatch("backstageLogin", {
          account: this.accountNumber,
          password: this.accountPassword
        });
        if (loginResponse.result === "success") {
          this.$store.dispatch(
            "setBackstageToken",
            loginResponse.data.api_token
          );
          this.$store.dispatch("setAdminLevel", loginResponse.data.level);
          Cookies.set("goldAdminUser", loginResponse.data);
          alert("登入成功");
          this.$router.push({ name: "admin_orderList" });
        } else if (loginResponse.result === "fail") {
          alert("帳號或密碼錯誤，請重新確認");
        }
      } catch (e) {
        alert(`錯誤訊息：${e.response.data.message}`);
      }
    },
    loginDataVerification() {
      this.accountNumberError = false;
      this.accountPasswordError = false;
      this.errorMessage = null;
      if (this.accountNumber == "") {
        this.accountNumberError = true;
        this.errorMessage = "您的帳號不能為空";
        return false;
      }
      if (this.accountPassword == "") {
        this.accountPasswordError = true;
        this.errorMessage = "您的密碼不能為空";
        return false;
      }
      return true;
    }
  }
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}
.admin-login {
  & > * {
    font-size: 17px;
  }
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  .logo-container {
    text-align: center;
    img {
      width: 55%;
    }
  }
  .login-container {
    width: 25%;
    margin-top: 25px;
    .title {
      color: $secondaryDeepColor1;
      margin-bottom: 5px;
    }
    .text {
      margin-bottom: 15px;
    }
    .text > input {
      width: 100%;
      padding: 16px;
      font-size: 17px;
      border: 1px solid $primaryDeepColor;
      &.error {
        @extend %input-error;
      }
    }
  }
  span {
    margin: 8px 0;
  }
  button {
    @extend %button;
  }
}
</style>
